module.exports = __webpack_public_path__ + "img/bg_en.fa6aef0a.jpg";